
jQuery(function($) {
    $('.woocommerce-ordering>select').select2({
        minimumResultsForSearch: -1,
        dropdownAutoWidth: true,
        dropdownCssClass: "orderby"
    });
});